import { render, staticRenderFns } from "./TopicActivity.vue?vue&type=template&id=5aacd994&scoped=true"
import script from "./TopicActivity.vue?vue&type=script&lang=js"
export * from "./TopicActivity.vue?vue&type=script&lang=js"
import style0 from "./TopicActivity.vue?vue&type=style&index=0&id=5aacd994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aacd994",
  null
  
)

export default component.exports